import React from 'react'

export const Plus: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, ...restProps }) => {
    return (
        <svg width={width || '24'} height={height || '24'} viewBox="0 0 24 24" fill="none" {...restProps}>
            <path d="M12 5V19M5 12H19" stroke="#1A1A1A" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
